<app-menu class="menuApp" xmlns="http://www.w3.org/1999/html"></app-menu>
<div class="main">
  <div style="width: 90%; margin: auto;">

    <div class="row reglaSection">
      <div class="reglaHeader">
        <h1 class="centerVert textXXM">{{this.localiser.get('contact.title')}}</h1>
      </div>
      <div style="width: 90%; margin: auto;">
        <div class="row contactFirstRow">
          <div class="col-4" style="margin: auto; border-right: 2px solid #18264F">

            <div class="row">
              <h3 class="textS+">{{this.localiser.get('contact.situation')}}</h3>
            </div>
            <div class="row">
              <h3 class="textS">{{this.localiser.get(this.contactService.getSituationUser())}}</h3>
            </div>

          </div>
          <div class="col-2" style="margin: auto; border-right: 2px solid #18264F">

            <div class="row">
              <h3 class="textS+">{{this.localiser.get('contact.priority')}}</h3>
            </div>
            <div class="row">
              <mat-select value="Consulta" class="textS" style="width: 80%" [(ngModel)]="prioridad">
                <mat-option class="textS" value="Consulta">{{this.localiser.get('contact.query')}}</mat-option>
                <mat-option class="textS" value="Prioritario">{{this.localiser.get('contact.high-priority')}}</mat-option>
              </mat-select>
            </div>

          </div>
          <div class="col-5" style="margin: auto">

            <div class="row">
              <div class="col">
                <h3 (click)="changeContactButton(0)" class="textS centerVert contactContactButton"
                [ngClass]="{selectedContactButton: this.contactButton[0]}">{{this.localiser.get('contact.technicalManager')}}</h3>
              </div>
              <div class="col">
                <h3 (click)="changeContactButton(1)" class="textS centerVert contactContactButton"
                    [ngClass]="{selectedContactButton: this.contactButton[1]}">{{this.localiser.get('contact.projectManager')}}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <h3 (click)="changeContactButton(2)" class="textS centerVert contactContactButton"
                    [ngClass]="{selectedContactButton: this.contactButton[2]}">{{this.localiser.get('contact.commercial')}}</h3>
              </div>
              <div class="col">
                <h3 (click)="changeContactButton(3)" class="textS centerVert contactContactButton"
                    [ngClass]="{selectedContactButton: this.contactButton[3]}">{{this.localiser.get('contact.administration')}}</h3>
              </div>
            </div>

          </div>
        </div>
        <div class="row">
          <input [(ngModel)]="titulo" type="text" placeholder="{{this.localiser.get('contact.placeHolderTitle')}}" class="inputTitle textS" maxlength="50">
        </div>
        <div class="row">
          <textarea [(ngModel)]="descripcion" maxlength="250" class="inputDescription textS" placeholder="{{this.localiser.get('contact.placeHolderDescription')}}"></textarea>
        </div>

        <div class="col" style="text-align: center">

          <div *ngIf="!actualizado" (click)="isButtonEnabledOpenIssue() ? newContacto() : null" 
               class="row customButtonColorReverse buttonSend textS"
               [ngClass]="{'buttonDisabled': !isButtonEnabledOpenIssue()}">

            <div class="col-9">
              {{this.localiser.get('contact.buttonSend')}}
            </div>
            <div class="col-3">
              <span class="material-icons-outlined customIcon">send</span>
            </div>

          </div>

          <div *ngIf="actualizado" class="row customButtonColorDone buttonSend textS">

            <div class="col-9">
              {{this.localiser.get('contact.buttonSended')}}
            </div>
            <div class="col-3">
              <span class="material-icons-outlined customIcon">done</span>
            </div>

          </div>

        </div>

      </div>
    </div>

    <div *ngIf="contactos.length > 0" class="row reglaSection">
      <div class="reglaHeader">
        <h1 class="centerVert textXXM">{{this.localiser.get('contact.communications')}}</h1>
      </div>
      <div class="reglaTable">
        <table style="width:100%">
          <tr class="bottom-border">
            <th class="textS+">{{this.localiser.get('contact.date')}}</th>
            <th class="textS+">{{this.localiser.get('contact.titleCom')}}</th>
            <th class="textS+">{{this.localiser.get('contact.state')}}</th>
            <th class="textS+">{{this.localiser.get('contact.contactTo')}}</th>
            <th class="textS+" *ngIf="this.user.getIdContacto() != '0'">{{this.localiser.get('contact.openBy')}}</th>
          </tr>
          <tr [ngClass]="{'inContact': isInContact(contacto.contactos)}" *ngFor="let contacto of contactos">
            <td class="textS">{{getStringTime(contacto.date)}}</td>
            <td class="textS">{{contacto.titulo}}</td>
            <td *ngIf="contacto.estado == 'Abierto'" class="textS">
              {{this.localiser.get('contact.stateOpen')}}
            </td>
            <td *ngIf="contacto.estado == 'Cerrado'" class="textS">
              {{this.localiser.get('contact.stateClose')}}
            </td>
            <td class="textS">{{getAddressedTo(contacto.contactos)}}</td>
            <td class="textS" *ngIf="this.user.getIdContacto() != '0'">{{contacto.nombreUsuario}}</td>
            <td (click)="toContactMessage(contacto)" class="textS link">{{this.localiser.get('contact.seeAnswers')}}</td>
          </tr>
        </table>
      </div>
    </div>

    <!--<img class="airImg" src="../../../assets/img/Airfal.png" alt="Airfal image">-->

  </div>
</div>
